var _path, _path2, _rect, _rect2, _circle, _path3, _rect3, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.5C4 7.46 6.46 5 9.5 5H22.5C25.54 5 28 7.46 28 10.5V18.5C28 21.54 25.54 24 22.5 24H13.5L8.2 28.6C7.55 29.16 6.55 28.7 6.55 27.84V23.4C5.03 22.42 4 20.71 4 18.77V10.5Z",
    fill: "#6EBAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17C4 17 8 21 16 21C24 21 28 17 28 17V18.5C28 21.54 25.54 24 22.5 24H13.5L8.2 28.6C7.55 29.16 6.55 28.7 6.55 27.84V23.4C5.03 22.42 4 20.71 4 18.77V17Z",
    fill: "#3A9BF0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10,
    width: 14,
    height: 2.4,
    rx: 1.2,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14.6,
    width: 9.5,
    height: 2.4,
    rx: 1.2,
    fill: "#123051"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 8.5,
    r: 5.5,
    fill: "#FCBE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 8.6L26.8 10.3L30 7",
    fill: "#FCBE00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.6,
    y: 5.6,
    width: 1.8,
    height: 4,
    rx: 0.9,
    fill: "#123051"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 11.2,
    r: 1,
    fill: "#123051"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/Comments.db28ed4ac016bc5c12574f6cd23654ed.svg";
export { ForwardRef as ReactComponent };